import { every } from 'lodash';
import { Component, ElementRef, OnInit, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.less'],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  @ViewChild('userMenuButton') public userMenuButtonRef: ElementRef;
  isUserDropdownShown: Boolean = false;

  onUserDropdownClick() {
    this.isUserDropdownShown = !this.isUserDropdownShown;
  }

  ngOnInit() {
    window.addEventListener('click', (event: MouseEvent & {path: Array<{}>}) => {
      if (every(event.path, node => this.userMenuButtonRef.nativeElement !== node)) {
        this.isUserDropdownShown = false;
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/app.component.ts